import { filterValues, memoizeReduxState, memoizeReduxStateForMultipleIds } from '@range.io/functional'
import memoizeResult from '../../memoize-result.js'
import { _field } from '../../selector-primitives.js'

const commentsAsArray = memoizeResult(state => Object.values(state.comments))

/*
 * All the comments for the selected Collaboration
 * @sig selectCommentsForCollaboration :: (State, Collaboration) -> [Comment]
 */
const commentsForSelectedCollaboration = state => {
    const { selectedCollaborationId } = state
    return filterValues(comment => comment.parentId === selectedCollaborationId, state.comments)
}

/*
 * Return all comments for the given Collaboration
 * @sig commentsForCollaboration :: (State, Collaboration) -> [Comment]
 */
const _commentsForCollaborationId = (state, id) => Object.values(state.comments).filter(c => c.parentId === id)
const commentsForCollaborationId = memoizeReduxStateForMultipleIds(['comments'], _commentsForCollaborationId)

const commentsForCollaboration = (state, collaboration) =>
    collaboration ? commentsForCollaborationId(state, collaboration.id) : []

/*
 * Return all comments for the given Upload
 * @sig commentsForUpload :: (State, Upload) -> [Comment]
 */
const _commentsForUpload = (state, upload) => {
    if (!upload) return []
    return commentsAsArray(state).filter(c => c.parentId === upload.id)
}

const commentsForUpload = memoizeReduxState(['uploads', 'collaborations', 'comments'], _commentsForUpload)

// ---------------------------------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------------------------------

const CommentSelectors = {
    commentsAsPOJO: _field('comments'),
    commentsForCollaboration,
    commentsForSelectedCollaboration,
    commentsForUpload,
}

export default CommentSelectors
